"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Asset Data Service API
 * ADS API Service is responsible for managing organization\'s assets
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rswarriors@arcticwolf.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MinimalDeviceToJSON = exports.MinimalDeviceFromJSONTyped = exports.MinimalDeviceFromJSON = exports.instanceOfMinimalDevice = exports.MinimalDeviceSourcesEnum = exports.MinimalDeviceImportanceEnum = exports.MinimalDeviceCategoryEnum = void 0;
var runtime_1 = require("../runtime");
var NetworkInterface_1 = require("./NetworkInterface");
var OperatingSystem_1 = require("./OperatingSystem");
var RiskEnrichments_1 = require("./RiskEnrichments");
/**
 * @export
 */
exports.MinimalDeviceCategoryEnum = {
    Unassigned: 'unassigned',
    Desktop: 'desktop',
    Firewall: 'firewall',
    Laptop: 'laptop',
    Server: 'server',
    Printer: 'printer',
    Network: 'network',
    Mobile: 'mobile',
    Embedded: 'embedded',
    Iot: 'iot',
    Other: 'other'
};
/**
 * @export
 */
exports.MinimalDeviceImportanceEnum = {
    Unassigned: 'unassigned',
    None: 'none',
    Low: 'low',
    Medium: 'medium',
    High: 'high',
    Critical: 'critical'
};
/**
 * @export
 */
exports.MinimalDeviceSourcesEnum = {
    Agent: 'agent',
    Eva: 'eva',
    Iva: 'iva'
};
/**
 * Check if a given object implements the MinimalDevice interface.
 */
function instanceOfMinimalDevice(value) {
    var isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "lastSeenTime" in value;
    isInstance = isInstance && "category" in value;
    isInstance = isInstance && "importance" in value;
    return isInstance;
}
exports.instanceOfMinimalDevice = instanceOfMinimalDevice;
function MinimalDeviceFromJSON(json) {
    return MinimalDeviceFromJSONTyped(json, false);
}
exports.MinimalDeviceFromJSON = MinimalDeviceFromJSON;
function MinimalDeviceFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'tags': !(0, runtime_1.exists)(json, 'tags') ? undefined : json['tags'],
        'tagIds': !(0, runtime_1.exists)(json, 'tag_ids') ? undefined : json['tag_ids'],
        'lastSeenTime': (new Date(json['last_seen_time'])),
        'deletedTime': !(0, runtime_1.exists)(json, 'deleted_time') ? undefined : (new Date(json['deleted_time'])),
        'idAliases': !(0, runtime_1.exists)(json, 'id_aliases') ? undefined : json['id_aliases'],
        'category': json['category'],
        'importance': json['importance'],
        'risk': !(0, runtime_1.exists)(json, 'risk') ? undefined : (0, RiskEnrichments_1.RiskEnrichmentsFromJSON)(json['risk']),
        'hostname': !(0, runtime_1.exists)(json, 'hostname') ? undefined : json['hostname'],
        'legacyDeviceIds': !(0, runtime_1.exists)(json, 'legacy_device_ids') ? undefined : json['legacy_device_ids'],
        'netbios': !(0, runtime_1.exists)(json, 'netbios') ? undefined : json['netbios'],
        'networkInterfaces': !(0, runtime_1.exists)(json, 'network_interfaces') ? undefined : (json['network_interfaces'].map(NetworkInterface_1.NetworkInterfaceFromJSON)),
        'os': !(0, runtime_1.exists)(json, 'os') ? undefined : (0, OperatingSystem_1.OperatingSystemFromJSON)(json['os']),
        'sources': !(0, runtime_1.exists)(json, 'sources') ? undefined : json['sources'],
    };
}
exports.MinimalDeviceFromJSONTyped = MinimalDeviceFromJSONTyped;
function MinimalDeviceToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'name': value.name,
        'tags': value.tags,
        'tag_ids': value.tagIds,
        'last_seen_time': (value.lastSeenTime.toISOString()),
        'deleted_time': value.deletedTime === undefined ? undefined : (value.deletedTime.toISOString()),
        'id_aliases': value.idAliases,
        'category': value.category,
        'importance': value.importance,
        'risk': (0, RiskEnrichments_1.RiskEnrichmentsToJSON)(value.risk),
        'hostname': value.hostname,
        'legacy_device_ids': value.legacyDeviceIds,
        'netbios': value.netbios,
        'network_interfaces': value.networkInterfaces === undefined ? undefined : (value.networkInterfaces.map(NetworkInterface_1.NetworkInterfaceToJSON)),
        'os': (0, OperatingSystem_1.OperatingSystemToJSON)(value.os),
        'sources': value.sources,
    };
}
exports.MinimalDeviceToJSON = MinimalDeviceToJSON;
